import React, { useEffect, useState } from 'react';
import PortsAutoComplete from 'components/common/PortsAutoComplete';
import _ from 'lodash';
import api from 'services';

const placeFields = ['placeFrom', 'placeTo'];
const regionFields = ['regionFrom', 'regionTo'];

function FromTo({
    field,
    data, 
    changeFieldsMultiple, 
    countIndex,
    required = false, 
    setHasErrors = (_a, _b) => {},
    mainRegions,
    withAreas,
    onlyAreas = false,
    isInBalticIndex = false,
}) {
    const [current, setCurrent] = useState(data);

    const selectPort = async (port) => {
        setCurrent(port);

        const toChange = [
            {
                index: countIndex,
                field,
                value: _.pick(port, ['_id', 'name']),
            },
        ];

        if (regionFields.includes(field)) {
            toChange.push({
                index: countIndex,
                field: field === 'regionFrom' ? 'placeFrom' : 'placeTo',
                value: {},
            });
        } else {
            const main = await api.getPortMainRegion(port._id);
            toChange.push({
                index: countIndex,
                field: field === 'placeFrom' ? 'regionFrom' : 'regionTo',
                value: _.pick(main.data[0] || {}, ['_id', 'name']),
            });
        }

        changeFieldsMultiple(toChange);
    }

    useEffect(() => {
        setCurrent(data);
    }, [data]);

    useEffect(() => {
        if (required && regionFields.includes(field)) {
            if (!data || !data._id) {
                setHasErrors(field, true);
            } else {
                setHasErrors(field, false);
            };
        }
    }, [current]);

    const handleChangeCustomValue = (value) => {
        changeFieldsMultiple([
            {
                index: countIndex,
                field,
                value,
            },
        ]);
    }

    return (
        <PortsAutoComplete 
            customValue={current ? current.name : ''}
            selectValue={selectPort}
            floatingLabelStyle={{ display: 'none' }}
            hintText={null}
            underlineStyle={{ display: 'none' }}
            inputStyle={{ fontSize: '10px' }}
            style={{ top: 'unset' }}
            menuStyle={{ width: '300px' }}
            popoverProps={{
                style: { width: '300px' }
            }}
            withAreas={withAreas}
            mainRegions={mainRegions}
            onlyAreas={onlyAreas}
            handleChangeCustomValue={handleChangeCustomValue}
            isInBalticIndex={isInBalticIndex}
        />
    );
}

export default React.memo(FromTo);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/FromTo.jsx